import { render, staticRenderFns } from "./event-photos.vue?vue&type=template&id=0773d112&"
import script from "./event-photos.vue?vue&type=script&lang=js&"
export * from "./event-photos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports